import axios from '../utils/ajax'
// 验证码
export const securityImageCode = params => axios.get('/securityImageCode?' + Math.random(),{
  params
})
// 注册
export const UserAuthorizationRegister = params => axios.get('/UserAuthorizationRegister',{
  params,
})
// 用户登录
export const loginByAccountAndPassWord = params => axios.get('/adminLoginByAccountAndPassWord',{
  params,
})

// 修改密码
export const chargePassWord = params => axios.get('/adminChargePassWord',{
  params,
})

// 权限
export const queryAuthority = () => axios.post('/managementPlatform/authority/queryAuthority');



// WEBPACK FOOTER //
// ./src/api/login.js